<template>
  <div id="report-found-base">
    <div class="base">
      <edit-input
        v-for="(info, index) in baseInfoList"
        v-model="reportDetail[info.value]"
        :key="index"
        :label="info.label"
        :options="info.options"
        :edit="visibleEdit"
        :readonly="!!info.readonly"
        :placeholder="info.placeholder"
      />
    </div>
    <div class="message">
      <edit-header title="巡查留言" :visibleAction="false" />
      <el-input
        type="textarea"
        v-model="reportDetail[messageValue]"
        class="message"
        :rows="10"
        resize="none"
        :class="{ readonly: !visibleEdit }"
        :readonly="!visibleEdit"
      />
    </div>
  </div>
</template>

<script>
import editHeader from '../layout/edit-header.vue';
import EditInput from '../layout/edit-input.vue';

export default {
  components: { editHeader, EditInput },
  name: 'ReportFoundBase',
  props: {
    reportDetail: {
      type: Object,
      default: () => ({})
    },
    visibleEdit: {
      type: Boolean
    }
  },
  data() {
    return {
      messageValue: 'inspectMessage',
      baseInfoList: [
        {
          label: '巡查状态',
          value: 'inspectStatusEnum',
          options: {
            type: 'select',
            list: [
              {
                label: '正常',
                value: 'NORMAL'
              },
              {
                label: '异常',
                value: 'ABNORMAL'
              },
              {
                label: '未巡查',
                value: 'WEIXUNCHA'
              }
            ]
          }
        },
        {
          label: '巡查类型',
          value: 'inspectTypeEnum',
          options: {
            type: 'select',
            list: [
              {
                label: '日常巡查',
                value: 'RICHAI'
              },
              {
                label: '定期巡查',
                value: 'DINGQI'
              },
              {
                label: '专项巡查',
                value: 'ZHUANXIANG'
              }
            ]
          }
        },
        {
          label: '建筑地址',
          value: 'relicAddress'
        },
        {
          label: '巡查人 ',
          value: 'inspectorNickName',
          readonly: true
        },
        {
          label: '巡查时间',
          readonly: true,
          value: 'createTime'
        },
        {
          label: '修订时间',
          readonly: true,
          value: 'updateTime'
        }
      ]
    };
  }
};
</script>
<style lang="scss">
#report-found-base {
  .base {
    padding-bottom: 10px;
    border-bottom: 1px solid $color-border-light;
  }
  .message {
    margin-top: 15px;
    .message {
      margin-top: 10px;
      &.readonly {
        .el-textarea {
          &__inner {
            box-shadow: unset;
            cursor: text;
            border: 0px;
          }
          &__suffix {
            display: none;
          }
        }
        .el-textarea__inner {
          line-height: 28px;
        }
      }
    }
  }
}
</style>
